"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils/utils");
var _consts = require("../consts");
var _wixAppsApi = _interopRequireDefault(require("./wixAppsApi"));
var _upgradeToBusinessPopup = _interopRequireDefault(require("../checkout/popupMessage/upgradeToBusinessPopup"));
var _photographyClientLib = require("@wix/photography-client-lib");
var CheckoutHandler = exports["default"] = /*#__PURE__*/function () {
  function CheckoutHandler(baseUrl, closeFullscreen) {
    this.baseUrl = baseUrl;
    this.closeFullscreen = closeFullscreen;
    this.checkoutParams = null;
    this.popupParams = {
      businessPlanUrl: null
    };
  }
  var _proto = CheckoutHandler.prototype;
  _proto.getCheckoutData = function getCheckoutData() {
    return this.checkoutParams;
  };
  _proto.setCheckoutData = function setCheckoutData(data) {
    this.checkoutParams = data;
  };
  _proto.handleCheckoutRequest = /*#__PURE__*/function () {
    var _handleCheckoutRequest = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(data, checkputParams) {
      var locale, additionalProviderParams, srcId, isAlbumStore, enableAlbumsStorePremiumValidation, enableMotherSiteAppInstance, isContainsDemoItems, shouldProceedToCheckout, motherSiteMetaSiteId, motherSiteAppInstance, appDefId, appsApi, _yield$appsApi$getSit, hasBusinessPackage, metaSiteId, modifiedCheckoutParams, modifiedData;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            locale = data.locale, additionalProviderParams = data.additionalProviderParams;
            srcId = additionalProviderParams.srcId, isAlbumStore = additionalProviderParams.isAlbumStore;
            enableAlbumsStorePremiumValidation = _photographyClientLib.experimentsWrapper.getExperimentBoolean('specs.pro-gallery.EnableAlbumsStorePremiumValidation');
            enableMotherSiteAppInstance = _photographyClientLib.experimentsWrapper.getExperimentBoolean('specs.pro-gallery.useMotherSiteAppInstance');
            isContainsDemoItems = this.containsDemoItems(data);
            shouldProceedToCheckout = true;
            motherSiteMetaSiteId = null;
            motherSiteAppInstance = null;
            if (!isContainsDemoItems) {
              _context.next = 13;
              break;
            }
            this.openDemoItemsPopup(data);
            shouldProceedToCheckout = false;
            _context.next = 34;
            break;
          case 13:
            if (!(enableAlbumsStorePremiumValidation && isAlbumStore)) {
              _context.next = 34;
              break;
            }
            appDefId = isAlbumStore ? _consts.ALBUMS.ALBUMS_APP_DEF_ID : _consts.ART_STORE.ARTSTORE_APP_DEFINITION_ID;
            appsApi = _wixAppsApi["default"][appDefId];
            _context.next = 18;
            return appsApi.getSiteBusinessPackageData(locale, srcId, this.baseUrl);
          case 18:
            _yield$appsApi$getSit = _context.sent;
            hasBusinessPackage = _yield$appsApi$getSit.hasBusinessPackage;
            metaSiteId = _yield$appsApi$getSit.metaSiteId;
            if (!enableMotherSiteAppInstance) {
              _context.next = 33;
              break;
            }
            motherSiteMetaSiteId = metaSiteId;
            _context.prev = 23;
            _context.next = 26;
            return appsApi.getMotherSiteAppInstance(motherSiteMetaSiteId, this.baseUrl);
          case 26:
            motherSiteAppInstance = _context.sent;
            _context.next = 33;
            break;
          case 29:
            _context.prev = 29;
            _context.t0 = _context["catch"](23);
            console.error('Failed to get mother site appInstance:', _context.t0);
            // Fallback to using original appInstance if appInstance cannot be resolved
            motherSiteAppInstance = null;
          case 33:
            if (!hasBusinessPackage) {
              this.popupParams.businessPlanUrl = appsApi.getSitebusinessPlanUrl(metaSiteId);
              this.openBusinessPackagePopup(data);
              shouldProceedToCheckout = false;
            }
          case 34:
            if (shouldProceedToCheckout) {
              if (enableMotherSiteAppInstance && motherSiteAppInstance) {
                modifiedCheckoutParams = (0, _extends2["default"])({}, checkputParams, {
                  srcId: motherSiteMetaSiteId
                });
                modifiedData = (0, _extends2["default"])({}, data, {
                  appInstance: motherSiteAppInstance
                });
                this.proceedToCheckout(modifiedData, modifiedCheckoutParams);
              } else {
                this.proceedToCheckout(data, checkputParams);
              }
            }
          case 35:
          case "end":
            return _context.stop();
        }
      }, _callee, this, [[23, 29]]);
    }));
    function handleCheckoutRequest(_x, _x2) {
      return _handleCheckoutRequest.apply(this, arguments);
    }
    return handleCheckoutRequest;
  }();
  _proto.openDemoItemsPopup = function openDemoItemsPopup(data) {
    var isMobile = data.isMobile,
      storeApi = data.storeApi;
    var width = isMobile ? '100%' : 600;
    var height = isMobile ? '100%' : 300;
    var url = _utils.utils.generateUrl('checkout-popup-message.html');
    storeApi.openPopup(url, {
      width: width,
      height: height
    });
    if (typeof this.closeFullscreen === 'function') {
      this.closeFullscreen();
    }
    data.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.CART, false);
  };
  _proto.openBusinessPackagePopup = function openBusinessPackagePopup(data) {
    data.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.STORE_POPUP_MESSAGE, true);
  };
  _proto.proceedToCheckout = function proceedToCheckout(data, additionalParams) {
    this.setCheckoutData(additionalParams || {});
    data.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.CHECKOUT, true);
  };
  _proto.containsDemoItems = function containsDemoItems(data) {
    var cartItems = data.cartItems;
    if (!cartItems) {
      return false;
    }
    var demoItems = cartItems.filter(function (item) {
      return item.isDemo;
    });
    return demoItems.length > 0;
  };
  _proto.getCheckoutPopupMessage = function getCheckoutPopupMessage(data) {
    return this.getUpgradeToBusinessPopup(data);
  };
  _proto.getUpgradeToBusinessPopup = function getUpgradeToBusinessPopup(data) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "artstore-popup-message-element-wrapper"
    }, /*#__PURE__*/_react["default"].createElement(_upgradeToBusinessPopup["default"], {
      isMobile: data.isMobile,
      viewMode: data.viewMode,
      businessPlanUrl: this.popupParams.businessPlanUrl,
      closePopup: function closePopup() {
        return data.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.STORE_POPUP_MESSAGE, false);
      }
    }));
  };
  return CheckoutHandler;
}();